import config from "config/config";
import { useLanguage } from "contexts/LocalizationContext/hooks";
import { useTranslations } from "contexts/LocalizationContext";
import { getLocalizedLogotypes } from "modules/common/utils/getLocalizedLogotypes";
import {
  ChakraImage as Image,
  ChakraText as Text,
  ChakraFlex as Flex,
  ChakraBox as Box,
} from "@airhelp/react-ui-components";

export const TrustedBrands = () => {
  const language = useLanguage();
  const logotypes = getLocalizedLogotypes(language);
  const translations = useTranslations();

  return (
    <Box width="100%">
      <Text
        fontWeight="medium"
        fontSize="sm"
        lineHeight="base"
        mb={4}
        color="greyscale.500"
        textAlign={{ base: "center", lg: "start" }}
      >
        {translations("trusted_by_brands")}
      </Text>
      <Flex gap={6} justify={{ base: "center", lg: "flex-start" }}>
        {logotypes.slice(0, 3).map(({ alt, imgPath }) => (
          <Image
            key={alt}
            src={`${config.staticUrl}/i/brand-logos/${imgPath}`}
            alt={alt}
            h={{ base: 6, lg: 8 }}
            loading="lazy"
          />
        ))}
      </Flex>
    </Box>
  );
};
